"use strict";

var _regeneratorRuntime = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canLoginWithGoogle = exports.resetPassword = exports.requestPasswordReset = exports.getAuth = exports.recoverPassword = exports.logout = exports.login = exports.setAuthAsync = void 0;

var __1 = require("..");

var api_1 = require("../../api");

var user_1 = require("../user");

var actions_1 = require("./actions");

var setAuthAsync = function setAuthAsync(auth) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch((0, actions_1.setAuth)(auth));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};

exports.setAuthAsync = setAuthAsync;

var login = function login(email, password, source, AbstractRouter, type) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var auth;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context2.prev = 1;
              auth = null;

              if (!(type == 'google')) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return (0, api_1.googleLoginRequest)(email, password);

            case 6:
              auth = _context2.sent;
              _context2.next = 12;
              break;

            case 9:
              _context2.next = 11;
              return (0, api_1.loginRequest)(email, password, source);

            case 11:
              auth = _context2.sent;

            case 12:
              if (!(auth.enabled === false)) {
                _context2.next = 16;
                break;
              }

              (0, exports.logout)();
              dispatch((0, actions_1.setLoading)(false));
              return _context2.abrupt("return", "disabledAccount");

            case 16:
              if (localStorage) {
                localStorage.setItem('token', auth.token);
              }

              _context2.next = 19;
              return dispatch((0, exports.setAuthAsync)(auth));

            case 19:
              _context2.next = 21;
              return dispatch((0, actions_1.hasLoggedIn)());

            case 21:
              _context2.next = 23;
              return dispatch((0, user_1.fetchUser)(auth.type, auth.typeId));

            case 23:
              if (AbstractRouter) {
                if (AbstractRouter.type === __1.AbstractRouterType.Action) {
                  dispatch(AbstractRouter.push('/'));
                } else {
                  AbstractRouter.push('/');
                }
              }

              _context2.next = 30;
              break;

            case 26:
              _context2.prev = 26;
              _context2.t0 = _context2["catch"](1);
              dispatch((0, actions_1.setLoading)(false));
              throw _context2.t0;

            case 30:
              dispatch((0, actions_1.setLoading)(false));

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 26]]);
    }));
  };
};

exports.login = login;

var logout = function logout(AbstractRouter) {
  return function (dispatch) {
    dispatch((0, actions_1.resetAuth)());
    dispatch((0, user_1.resetUser)());
    dispatch((0, actions_1.resetToken)());

    if (localStorage) {
      localStorage.removeItem('token');
    }

    if (AbstractRouter) {
      if (AbstractRouter.type === __1.AbstractRouterType.Action) {
        dispatch(AbstractRouter.push('/'));
      } else {
        AbstractRouter.push('/');
      }
    }
  };
};

exports.logout = logout;

var recoverPassword = function recoverPassword(email) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context3.prev = 1;
              _context3.next = 4;
              return (0, api_1.recoverPasswordRequest)(email);

            case 4:
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              console.error(_context3.t0);

            case 9:
              dispatch((0, actions_1.setLoading)(false));

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 6]]);
    }));
  };
};

exports.recoverPassword = recoverPassword;

var getAuth = function getAuth() {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var auth;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context4.prev = 1;

              if (getState().authState.token) {
                _context4.next = 5;
                break;
              }

              dispatch((0, actions_1.resetToken)());
              return _context4.abrupt("return");

            case 5:
              (0, api_1.setAxiosToken)(getState().authState.token);
              _context4.next = 8;
              return (0, api_1.apiRequest)('GET', '/account');

            case 8:
              auth = _context4.sent;
              _context4.next = 11;
              return dispatch((0, user_1.fetchUser)(auth.type, auth.typeId));

            case 11:
              dispatch((0, actions_1.setAuth)(auth));
              _context4.next = 18;
              break;

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](1);
              console.error(_context4.t0);
              dispatch((0, actions_1.resetToken)());

            case 18:
              dispatch((0, actions_1.setLoading)(false));

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 14]]);
    }));
  };
};

exports.getAuth = getAuth;

var requestPasswordReset = function requestPasswordReset(from, email) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context5.prev = 1;
              _context5.next = 4;
              return (0, api_1.apiRequest)('GET', '/account/reset-password', {}, {
                for: from,
                email: email
              });

            case 4:
              _context5.next = 9;
              break;

            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](1);
              console.error(_context5.t0);

            case 9:
              dispatch((0, actions_1.setLoading)(false));

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 6]]);
    }));
  };
};

exports.requestPasswordReset = requestPasswordReset;

var resetPassword = function resetPassword(token, newPassword) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6() {
      var httpError;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch((0, actions_1.unsetError)());
              dispatch((0, actions_1.setLoading)(true));
              _context6.prev = 2;
              _context6.next = 5;
              return (0, api_1.apiRequest)('POST', '/account/reset-password', {
                token: token,
                newPassword: newPassword
              });

            case 5:
              _context6.next = 12;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](2);
              console.error(_context6.t0);
              httpError = _context6.t0;

              if (httpError.response) {
                dispatch((0, actions_1.setError)(httpError.response.status));
              }

            case 12:
              dispatch((0, actions_1.setLoading)(false));

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 7]]);
    }));
  };
};

exports.resetPassword = resetPassword;

var canLoginWithGoogle = function canLoginWithGoogle(email) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return (0, api_1.apiRequest)('GET', "/account/google/canLogin?email=".concat(email));

            case 3:
              return _context7.abrupt("return", _context7.sent);

            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](0);
              console.error(_context7.t0);
              return _context7.abrupt("return", {
                canLogin: false
              });

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 6]]);
    }));
  };
};

exports.canLoginWithGoogle = canLoginWithGoogle;